export default __webpack_public_path__ + "static/media/sg.12919d62.svg";